import { URLS } from '../constants'
import { dispatchFetchGet, dispatchFetchPost } from './ActionsUtil'
import {
  GET_ALL_VALID_PLANS_BEGIN, GET_ALL_VALID_PLANS_SUCCESS, GET_ALL_VALID_PLANS_FAILURE, CLEAR_PLANS,
  POST_CREATE_PLAN_BEGIN, POST_CREATE_PLAN_SUCCESS, POST_CREATE_PLAN_FAILURE
} from '../constants/ActionTypes'


const acGetValidPlansBegin = () => ({ type: GET_ALL_VALID_PLANS_BEGIN, })
const acGetValidPlansSuccess = payload => ({
  type: GET_ALL_VALID_PLANS_SUCCESS, payload: { response: payload }
})
const acGetValidPlansFailure = err => ({
  type: GET_ALL_VALID_PLANS_FAILURE, payload: err
})

export const acGetValidPlans = () => {
  return dispatchFetchGet(
    `${URLS.PLAN.ROOT}`,
    acGetValidPlansBegin,
    acGetValidPlansSuccess,
    acGetValidPlansFailure,
  )
}

export const acClearPlans = () => ({ type: CLEAR_PLANS })

const acPostCreatePlanBegin = () => ({ type: POST_CREATE_PLAN_BEGIN, })
const acPostCreatePlanSuccess = payload => ({
  type: POST_CREATE_PLAN_SUCCESS, payload: { response: payload }
})
const acPostCreatePlanFailure = err => ({
  type: POST_CREATE_PLAN_FAILURE, payload: err
})

export const acPostCreatePlan = (name, valid_until, description, discount, special, trial, transition_only) => {
  return dispatchFetchPost(
    `${URLS.PLAN.ROOT}`,
    {
      name, valid_until, description, discount, special, trial, transition_only
    },
    acPostCreatePlanBegin,
    acPostCreatePlanSuccess,
    acPostCreatePlanFailure,
  )
}